<template>
  <div>
    <table width="100%" class="TB_COLLAPSE">
      <thead>
        <tr>
          <th>选项</th>
          <th colspan="3">内容</th>
        </tr>
      </thead>
      <tbody>
        <tr class="tc">
          <th width="25%"></th>
          <th width="25%">累计占成</th>
          <th width="25%">下调水位</th>
          <th v-if="highAdmin" width="25%">最低倍率</th>
        </tr>
        <tr v-for="(it,index) in attodoge_data" :key="index+'wlsge_data'" class="tc">
          <th>{{it[keyName.name]}}</th>
          <td>
            <InputNumber
              v-model.number="it[keyName.total]"
              style="width:120px;"
              @on-change="setItems(it, keyName.total, 1)"
            />
          </td>
          <td>
            <InputNumber
              v-model="it[keyName.down]"
              style="width:120px;"
              :step="0.001"
              @on-change="setItems(it, keyName.down, 2)"
            />
          </td>
          <td v-if="highAdmin">
            <InputNumber v-model="it.adod" style="width:120px;" :step="0.1" @on-change="setItems(it, 'adod', 3)" />
          </td>
        </tr>
      </tbody>
    </table>
    <Row type="flex" align="middle" justify="center" class="mt-4 mb-2">
      <Button type="error" size="large" @click="modify">储存</Button>
    </Row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'auto-diving',
  data () {
    return {
      attodoge_data: [],
      items: []
    };
  },
  computed: {
    ...mapGetters(['getmember', 'getgameid']),
    highAdmin () {
      return this.$route.name == 'auto-diving'
    },
    keyName () {
      if (this.highAdmin) {
        return {
          id: 'id',
          value: 'newvalue',
          urlKey: 'hfl',
          url: `attodoge`,
          modifyUrl: 'attodopo',
          total: 'atto',
          down: 'atdo',
          name: 'adname'
        }
      } else {
        return {
          id: 'adid',
          value: 'oddsvalue',
          urlKey: 'six',
          url: 'stattodoge',
          modifyUrl: 'stattodopo',
          total: 'atto',
          down: 'atdo',
          name: 'adname'
        }
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.attodoge();
    },
    getgameid () {
      this.attodoge();
    }
  },
  created () {
    this.attodoge();
  },
  methods: {
    async attodoge () {
      try {
        const res = await this.$axios.setting.getAutoDiving(this.keyName.urlKey, this.keyName.url, this.getgameid)
        if ('status' in res && res.status === 0) return
        
        if (this.highAdmin) {
          const pmidAry = [22]
          pmidAry.forEach(pmid => {
            const ind = 10
            res.splice(ind, 0, ...res.splice(-1, 1))
          });
        }
        this.attodoge_data = res.filter(it => it.adid !== 9)
      } catch (error) {
        console.error(error)
      }
    },
    setItems (it, key, pmtstge) {
      let flat = true;
      if (this.items.length) {
        this.items.forEach(res => {
          if (res[this.keyName.id] == it.adid && res.attodoge == pmtstge) {
            flat = false;
            res[this.keyName.value] = it[key].toString();
          }
        });
      }
      if (!this.items || flat) {
        this.items.push({
          [this.keyName.id]: Number(it.adid),
          [this.keyName.value]: it[key].toString(),
          attodoge: pmtstge
        });
      }
    },
    async modify () {
      try {
        const obj = {
          loid: this.getmember.pid,
          gameid: this.getgameid,
          items: this.items
        }
        let status = false
        for (let i = 0; i < obj.items.length; i++) {
          if (obj.items[i].attodoge == 3) {
            if (Number(obj.items[i].newvalue) < 1) {
              status = true
              break;
            }
          }
        }
        if (status) return this.$Message.error({ content: '赔率不可低于 1' })
        const key = this.$route.name == 'auto-diving' ? 'newvalue' : 'oddsvalue'
        if (obj.items.map(it => it[key]).some(it => isNaN(it))) return this.$Message.error({ content: '请输入数字格式' })
        const res = await this.$axios.setting.modifyAutoDiving(this.keyName.urlKey, this.keyName.modifyUrl, this.getgameid, obj)
        if (res.status !== 1) return this.$Message.error("修改失败")
        this.$Message.success("修改成功");
        this.items = []
      } catch (error) {
        console.error(error);
        this.$Message.error("栏位异常");
      }
    }
  }
};
</script>
